import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const CartResult = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(CartResult);
